import React from 'react';

import './Groupbox.css';

export default class Groupbox extends React.Component{
    render(){
        return(
            
            <div className="groupbox">
                <span className="grouptitle">{this.props.header}</span>
               {this.props.children}
            </div>
             
        );
    }
}